
export enum DriverSourceCd {
	BOTH = 'Both',
	LINEHAUL = 'Linehaul',
	PN_D = 'PnD'}
